<div class="chart-header">
  <h5>{{ title }}</h5>
  <nb-icon
    icon="question-mark-circle-outline"
    nbPopover="{{ infoText }}"
    nbPopoverTrigger="hover"
    nbPopoverPlacement="bottom"
    nbPopoverClass="max-width-popover"
  ></nb-icon>

  <app-demo-badge *ngIf="isDemo"></app-demo-badge>
</div>
